<template>
    <div>
      <ul class="nav nav-tabs m-0 p-0" role="tablist">
        <li class="nav-item cp_pointer">
          <router-link :class="['nav-link', tab == 'transactions-list' ? 'active': '']" to="/transactions/transactions-list"
             data-toggle="tab"
             role="tab" aria-selected="false"
             style="cursor:pointer;"
          >
            لیست تراکنش ها
          </router-link>
        </li>
        <li class="nav-item cp_pointer">
          <router-link :class="['nav-link', tab == 'excels-list' ? 'active': '']" to="/transactions/excels-list"
             data-toggle="tab"
             role="tab" aria-selected="false"
             style="cursor:pointer;"
          >
            لیست خروجی های اکسل
          </router-link>
        </li>
      </ul>

      <div class="tab-content">
        <div :class="['tab-pane', tab == 'transactions-list' ? 'active':'']" id="transactions-list">
            <page-title title_text="تراکنش‌ها" icon="transactions">
              <!--            <button-->
              <!--                    class="btn btn border bg-white shadow-sm mx-2 px-4 py-2"-->
              <!--                    type="button"-->
              <!--                    style="border-radius: 20px; border-color: #bbb"-->
              <!--                    @click="exportToExcel()"-->
              <!--            >-->
              <!--                <svg-->
              <!--                        xmlns="http://www.w3.org/2000/svg"-->
              <!--                        enable-background="new 0 0 24 24"-->
              <!--                        height="24"-->
              <!--                        viewBox="0 0 24 24"-->
              <!--                        width="24"-->
              <!--                        fill="#00bea5"-->
              <!--                >-->
              <!--                    <g><rect fill="none" height="24" width="24" /></g>-->
              <!--                    <g>-->
              <!--                        <path-->
              <!--                                d="M16.59,9H15V4c0-0.55-0.45-1-1-1h-4C9.45,3,9,3.45,9,4v5H7.41c-0.89,0-1.34,1.08-0.71,1.71l4.59,4.59 c0.39,0.39,1.02,0.39,1.41,0l4.59-4.59C17.92,10.08,17.48,9,16.59,9z M5,19c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1s-0.45-1-1-1H6 C5.45,18,5,18.45,5,19z"-->
              <!--                        />-->
              <!--                    </g>-->
              <!--                </svg>-->
              <!--                <span class="pr-2">خروجی اکسل</span>-->
              <!--            </button>-->
              <button
                  class="btn btn border bg-white shadow-sm mx-2 px-4 py-2"
                  type="button"
                  style="border-radius: 20px; border-color: #bbb"
                  data-toggle="modal"
                  data-target="#advance_modal"
              >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    fill="#00bea5"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path
                      d="M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                  />
                </svg>
                <span class="pr-2">جستجوی پیشرفته</span>
              </button>
            </page-title>
            <div class="modal fade" id="advance_modal" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body">
                    <div class="text-center">جستجوی پیشرفته</div>
                    <form class="mt-5 mx-5 mb-2" id="advance_filter">
                      <div class="d-flex align-items-center">
                        <div class="form-group m-3 w-50">
                          <input
                              type="text"
                              class="form-control"
                              placeholder="شناسه تراکنش"
                              style="border-radius: 10px"
                              v-model="filter_id"
                          />
                        </div>
                        <div class="form-group m-3 w-50">
                          <input
                              type="text"
                              class="form-control"
                              placeholder="شماره مرجع بانکی"
                              style="border-radius: 10px"
                              v-model="filter_ref_id"
                          />
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="form-group m-3 w-50">
                          <input
                              type="text"
                              class="form-control"
                              placeholder="مبلغ تراکنش"
                              style="border-radius: 10px"
                              v-model="filter_price"
                          />
                        </div>
                        <div class="form-group m-3 w-50">
                          <input
                              type="text"
                              class="form-control"
                              placeholder="شماره کارت/شبا پرداخت کننده"
                              style="border-radius: 10px"
                              v-model="filter_card_number"
                              maxlength="16"
                          />
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="form-group m-3 w-50">
                          <input
                              type="text"
                              class="form-control"
                              placeholder="شماره سفارش"
                              style="border-radius: 10px"
                              v-model="filter_order_id"
                          />
                        </div>
                        <div class="form-group m-3 w-50">
                          <input
                              dir="ltr"
                              type="text"
                              id="filter_phone"
                              name="filter_phone"
                              class="form-control"
                              placeholder="شماره موبایل"
                              style="border-radius: 10px"
                              v-model="filter_phone"
                          />
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="form-group m-3 w-50">
                          <input
                              type="text"
                              class="form-control"
                              placeholder="شناسه پرداخت (ref_num)"
                              style="border-radius: 10px"
                              v-model="filter_ref_num"
                          />
                        </div>
                        <div class="form-group m-3 w-50 tx-type-filter">
                          <select
                              multiple
                              class="form-control kt-selectpicker"
                              v-model="advance_transaction_type"
                              id="advance_transaction_type"
                              name="advance_transaction_type"
                          >
                            <option
                                v-for="transaction in transactionsTypes"
                                :key="transaction.name"
                                :value="transaction.value"
                                :disabled="transaction.disable"
                                :selected="transaction.disable ? true : false">
                              {{ transaction.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="form-group m-3 w-50" v-if="shop_data_gateway_status == 'success'">
                          <select
                              class="form-control kt-selectpicker"
                              v-model="selectedShop"
                              name="filter_gateway"
                              id="filter_gateway"
                          >
                            <option :value="null" selected disabled>{{ $t('label.gateway') }}</option>
                            <option
                                v-for="shop in shop_data_gateway"
                                :key="shop.hashid"
                                :value="shop"
                            >
                              {{ shop.title }} - {{ getShopType(shop.shop_type) }} - {{ shop.sequence }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group m-3 w-50" v-if="selectedShop !== null">
                          <select
                              class="form-control kt-selectpicker"
                              v-model="filter_terminal_number"
                              name="terminal_number"
                              id="terminal_number"
                          >
                            <option :value="null" selected disabled>{{ $t('label.terminal_number') }}</option>
                            <option
                                v-for="terminal in filteredTerminals"
                                :key="terminal.id"
                                :value="terminal.id"
                            >
                              {{ $t(`psp.${terminal.psp}`) }} - {{ terminal.number || 'N/A' }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group m-3 w-50">
                          <input
                              dir="ltr"
                              type="text"
                              id="filter_email"
                              name="filter_email"
                              class="form-control"
                              placeholder="ایمیل"
                              style="border-radius: 10px"
                              v-model="filter_email"
                          />
                        </div>
                      </div>

                      <div class="d-flex justify-content-center mt-4">
                        <button
                            type="button"
                            class="btn btn-success px-5"
                            style="border-radius: 20px"

                            @click="advance_get_data(transactions.first_page_url)"
                        >
                          جستجو
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
              <div class="row">
                <div class="col-sm my-2">
                  <div class="form-group my-0 tx-type-filter">
                    <select
                        size="5"
                        multiple
                        class="form-control kt-selectpicker"
                        v-model="filter_transaction_type"
                        id="filter_transaction_type"
                    >
                      <option
                          v-for="transaction in transactionsTypes"
                          :key="transaction.name"
                          :value="transaction.value"
                          :disabled="transaction.disable"
                          :selected="transaction.disable ? true : false"
                      >{{ transaction.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm my-2">
                  <div class="form-group my-0">
                    <select
                        class="form-control kt-selectpicker"
                        v-model="filter_status"
                        id="filter_status"
                    >
                      <option :value="null" selected disabled>وضعیت</option>
                      <option value="INIT">در انتظار پرداخت</option>
                      <option value="FAILED">ناموفق</option>
                      <option value="SUCCEED">موفق</option>
                      <option value="CANCELED">منصرف شده</option>
                      <option value="UNVERIFIED">عدم تایید پذیرنده</option>
                      <option value="SWITCHED">هدایت شده به PSP دیگر</option>
                      <option value="EXPIRED">منقضی شده</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm my-2">
                  <div class="form-group my-0">
                    <datePicker
                        color="#00c1a4"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY HH:mm"
                        input-class="form-control"
                        id="filter_from_date"
                        name="filter_from_date"
                        placeholder="از تاریخ"
                        clearable
                        v-model="filter_from_date"
                        type="datetime"
                    />
                  </div>
                </div>
                <div class="col-sm my-2">
                  <div class="form-group my-0">
                    <datePicker
                        color="#00c1a4"
                        format="YYYY-MM-DD HH:mm:ss"
                        display-format="dddd jDD jMMMM jYYYY HH:mm"
                        input-class="form-control"
                        id="filter_to_date"
                        name="filter_to_date"
                        placeholder="تا تاریخ"
                        clearable
                        v-model="filter_to_date"
                        type="datetime"
                    />
                  </div>
                </div>
                <div class="col-sm my-2">
                  <div class="d-flex">
                    <button
                        :class="query ? 'btn btn-success' : 'btn btn-success btn-block'"
                        style="border-radius: 10px"
                        @click="get_data(transactions.first_page_url)"
                    >
                      اعمال فیلتر
                    </button>
                    <button
                        class="btn btn-danger mr-1"
                        style="border-radius: 10px"
                        @click="reset_and_get"
                        v-if="query"
                    >
                      حذف فیلتر
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-md-6">
                <div class="bg-white p-3 h-100" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
                  <p class="mx-2">جمع کل</p>
                  <p class="text-center h3">{{ statistics.transactions_sum + ' ریال' }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="bg-white p-3 h-100 mt-sm-size" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
                  <p class="mx-2">تعداد تراکنشهای موفق</p>
                  <p class="text-center h3">{{ statistics.succeeded_trans_count }}</p>
                </div>
              </div>
            </div>

            <div v-if="has_error" class="alert alert-warning" v-text="error_message"></div>

            <div
                v-if="is_init"
                class="bg-white shadow-sm py-3 my-4"
                style="border-radius: 10px"
            >
              <div class="px-3">
                <!-- Mobile: card rows (same style as dashboard recent-transactions) -->
                <div class="d-md-none">
                  <div
                      class="transaction-mobile-card"
                      v-for="(transaction, index) in transactions.data"
                      :key="'m' + index"
                  >
                    <router-link class="text-reset text-decoration-none" :to="'/transactions/' + transaction.id + '/details'">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="transaction-id en_num">{{ transaction.id }}</span>
                        <span
                            :class="[
                            'label label-inline' +
                              ' label-light-' +
                              statusVariant(transaction.status),
                            transaction.status == 'SUCCEED' ? 'px-4' : '',
                          ]"
                        >
                          {{ statusStr.get(transaction.status) }}
                        </span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span>
                          <span v-if="transaction.transaction_type == 'پرداختیاری *'">پرداخت‌یاری +</span>
                          <span v-else-if="transaction.transaction_type == 'transaction.out_source'">خارج از سامانه</span>
                          <span v-else>{{ transaction.transaction_type }}</span>
                        </span>
                        <span class="transaction-price en_num">{{ transaction.price }} <small class="text-muted">ریال</small></span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center transaction-meta">
                        <span class="en_num" v-text="toPersianDateFormat(transaction.created_at)"></span>
                        <span>{{ transaction.port || '-' }}</span>
                      </div>
                    </router-link>
                  </div>
                  <div class="text-center py-5 d-md-none" v-if="transactions.data.length == 0">
                    <img src="@/assets/new/image/not-found_new.png" width="160" />
                  </div>
                </div>

                <!-- Desktop: table as before -->
                <div class="d-none d-md-block table-responsive">
                  <table
                      class="table table-responsive table-borderless text-center"
                      v-if="transactions.data.length > 0"
                  >
                    <thead>
                    <tr>
                      <th
                          scope="col"
                          style="background-color: #eee; border-radius: 0 16px 16px 0"
                      >
                        کشور
                      </th>
                      <th scope="col" style="background-color: #eee">شناسه تراکنش</th>
                      <th
                          scope="col"
                          style="background-color: #eee; cursor: pointer"
                          @click="sortBy('price')"
                      >
                        <span class="mx-2">مبلغ (ریال)</span>
                        <span v-if="sort_field == 'price'">
                    <span v-if="sort_sort == 'asc'">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                        />
                      </svg>
                    </span>
                  </span>
                      </th>
                      <th scope="col" style="background-color: #eee">نوع تراکنش</th>
                      <th scope="col" style="background-color: #eee">شماره مرجع بانکی</th>
                      <th scope="col" style="background-color: #eee">پی اس پی / بانک</th>
                      <th
                          scope="col"
                          style="background-color: #eee; cursor: pointer"
                          @click="sortBy('created_at')"
                      >
                        <span class="mx-2">تاریخ</span>
                        <span v-if="sort_field == 'created_at'">
                    <span v-if="sort_sort == 'asc'">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                        />
                      </svg>
                    </span>
                  </span>
                      </th>
                      <th
                          scope="col"
                          style="background-color: #eee; cursor: pointer"
                          @click="sortBy('status')"
                      >
                        <span class="mx-2">وضعیت</span>
                        <span v-if="sort_field == 'status'">
                    <span v-if="sort_sort == 'asc'">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                        />
                      </svg>
                    </span>
                  </span>
                      </th>
                      <th
                          scope="col"
                          style="background-color: #eee; border-radius: 16px 0 0 16px"
                      >
                        جزییات
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(transaction, index) in transactions.data"
                        :key="index"
                    >
                      <td v-if="transaction.country == null">
                        <country-flag country="ir" size="normal"></country-flag>
                      </td>
                      <td v-else>
                        <country-flag
                            :country="transaction.country"
                            size="normal"
                        ></country-flag>
                      </td>
                      <td class="en_num">{{ transaction.id }}</td>
                      <td>{{ transaction.price }}</td>
                      <td v-if="transaction.transaction_type == 'پرداختیاری *'">
                        <span>پرداخت‌یاری +</span>
                      </td>
                      <td
                          v-else-if="
                    transaction.transaction_type == 'transaction.out_source'
                  "
                      >
                        خارج از سامانه
                      </td>
                      <td v-else>{{ transaction.transaction_type }}</td>
                      <td>
                        {{ transaction.ref_id || "-" }}
                      </td>
                      <td>
                        <div v-if="transaction.port_code == 'MELLAT'">
                          <img src="/assets/media/psp/mellat.png" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'PARSIAN'">
                          <img src="/assets/media/psp/parsian.svg" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'PASARGAD'">
                          <img src="/assets/media/psp/pasargad.svg" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'SAMAN'">
                          <img src="/assets/media/psp/saman.svg" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'NOVIN'">
                          <img src="/assets/media/psp/novin.svg" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'SEPEHR'">
                          <img src="/assets/media/psp/sepehr.png" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'IRANKISH'">
                          <img src="/assets/media/psp/irankish.png" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'ASANPARDAKHT'">
                          <img src="/assets/media/psp/ap-logo.png" width="32" height="32">
                        </div>
                        <div v-else-if="transaction.port_code == 'SADERAT'">
                          <img src="/assets/media/psp/saderat.png" width="32" height="32">
                        </div>
                        <div v-else v-text="transaction.port"></div>
                      </td>
                      <td v-text="toPersianDateFormat(transaction.created_at)"></td>
                      <td>
                  <span
                      style="white-space: nowrap"
                      :class="[
                      'label label-inline' +
                        ' label-light-' +
                        statusVariant(transaction.status),
                      transaction.status == 'SUCCEED' ? 'px-4' : '',
                    ]"
                  >
                    {{ statusStr.get(transaction.status) }}
                  </span>
                      </td>
                      <td>
                        <router-link
                            :to="'/transactions/' + transaction.id + '/details'"
                        >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="20"
                              viewBox="0 0 24 24"
                              width="20"
                              fill="#bbb"
                          >
                            <path d="M0 0h24v24H0V0z" fill="none" />
                            <path
                                d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                            />
                          </svg>
                        </router-link>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="empty-table" style="height: 300px" v-else>
                    <table class="table table-responsive table-borderless text-center">
                      <thead>
                      <tr>
                        <th
                            scope="col"
                            style="background-color: #eee; border-radius: 0 16px 16px 0"
                        >
                          کشور
                        </th>
                        <th scope="col" style="background-color: #eee">کد تراکنش</th>
                        <th scope="col" style="background-color: #eee">
                          مبلغ (ریال)
                        </th>
                        <th scope="col" style="background-color: #eee">نوع تراکنش</th>
                        <th scope="col" style="background-color: #eee">شماره مرجع بانکی</th>
                        <th scope="col" style="background-color: #eee">پی اس پی / بانک</th>
                        <th scope="col" style="background-color: #eee">تاریخ</th>
                        <th scope="col" style="background-color: #eee">وضعیت</th>
                        <th
                            scope="col"
                            style="background-color: #eee; border-radius: 16px 0 0 16px"
                        >
                          جزییات
                        </th>
                      </tr>
                      </thead>
                    </table>
                    <div class="not-found" style="margin: 0 auto">
                      <img src="@/assets/new/image/not-found_new.png" width="200" />
                    </div>
                  </div>
                </div>
              </div>

              <hr v-if="transactions.next_page_url || transactions.prev_page_url" />

              <pagination
                  :data="transactions"
                  :get_data="get_data"
                  :perpage="perpage"
              ></pagination>
            </div>

            <div id="overlay" v-if="status == 'loading'">
              <div
                  class="p-3"
                  style="
          position: absolute;
          top: 50%;
          left: 50%;
          color: gray;
          background-color: white;
        "
              >
                <div class="spinner-border text-success" role="status"></div>
                <span> لطفا صبر کنید </span>
              </div>
            </div>
        </div>

        <div :class="['tab-pane', tab == 'excels-list' ? 'active':'']" id="excels-list">
          <div id="overlay" v-if="status == 'loading'">
            <div
                class="p-3"
                style="
          position: absolute;
          top: 50%;
          left: 50%;
          color: gray;
          background-color: white;
        "
            >
              <div class="spinner-border text-success" role="status"></div>
              <span> لطفا صبر کنید </span>
            </div>
          </div>
          <ExcelRequests
              :excel-requests="excelRequests"
              @handle-excel-export="excelExport"
              :transaction-types="transactionTypes"
          />
        </div>
      </div>
    </div>
</template>

<script>
    import { ApiService, ApiUrl } from "@/common/api.service";
    import {
        statusVariant,
        statusStr,
        transactionStatus,
    } from "@/constants/transactionStatus";
    import { transactionTypes, transactionStr } from "@/constants/transactionTypes";
    import $ from "jquery";
    import { i18n } from "@/plugins/i18n";
    import Pagination from "@/components/main/pagination";
    import PageTitle from "@/components/main/components/pageTitle";
    import axios from "axios";
    import  { AllShopTypes } from "@/constants/AllShopTypes"
    import {mapGetters} from "vuex";
    import Inputmask from 'inputmask'
    import toastr from "toastr";
    import {transactionsTypes} from '@/constants/TransactionsTypes';
    import ExcelRequests from "@/pages/transactions/components/ExcelRequests.vue";
    import {transactionService} from "@/common/api.service";


    export default {
        components: {ExcelRequests, PageTitle, Pagination },
        props: ["changeStatus"],
        data() {
            return {
                has_error: false,
                error_message: '',
                perpage: {
                    value: 15,
                },
                is_init: false,
                status: "loading",
                transactions: null,
                filter_id: "",
                filter_ref_id: "",
                filter_price: "",
                filter_gateway : null,
                filter_card_number: "",
                filter_ref_num: "",
                filter_terminal_number: null,
                filter_transaction_type: [],
                advance_transaction_type: [],
                filter_status: null,
                filter_from_date: null,
                filter_to_date: null,
                filter_phone: '',
                filter_order_id: '',
                sort_field: null,
                sort_sort: "desc",
                statusVariant,
                statusStr,
                transactionTypes,
                transactionStr,
                transactionStatus,
                transactionsTypes,
                transactionInformation:{},
                transactions_list: true,
                excel_requests_list: false,
                selectedShop: null,
                selectedTerminal: null,
                filteredTerminals: [],
                filter_email: null,
            };
        },
        computed: {
            tab() {
              if (this.$route.params.tab) {
                return this.$route.params.tab;
              }

              return 'transactions-list';
            },
            ...mapGetters('gateway', [
                'shop_data_gateway',
                'shop_data_gateway_status'
            ]),
            ...mapGetters('transaction', [
            'statistics' , 'excelRequests'
            ]),
            query() {
                let res = "";

                if (this.filter_terminal_number !== null) {
                  res = res + "&query[terminal_number]=" + this.filter_terminal_number;
                }

                if (this.filter_ref_id != "") {
                    res = res + "&query[ref_id]=" + this.filter_ref_id;
                }

                if (this.filter_id != "") {
                    res = res + "&query[id]=" + this.filter_id;
                }

                if (this.filter_price != "") {
                    res = res + "&query[price]=" + this.filter_price;
                }

                if (this.filter_card_number != "") {
                    res = res + "&query[card_number]=" + this.filter_card_number;
                }

                if (this.filter_transaction_type.length > 0) {
                  this.filter_transaction_type.forEach((type, index) => {
                      res = res + `&query[transaction_type][${index}]=` + type;
                  })
                }

                if (this.advance_transaction_type.length) {
                  this.advance_transaction_type.forEach((type, index) => {
                    res = res + `&query[transaction_type][${index}]=` + type;
                  })
                }

                if (this.filter_ref_num != "") {
                    res = res + "&query[ref_num]=" + this.filter_ref_num;
                }

                if (this.filter_status != null) {
                    res = res + "&query[status]=" + this.filter_status;
                }

                if (this.filter_from_date != null) {
                    res = res + "&query[from_date]=" + this.filter_from_date;
                }

                if (this.filter_to_date != null) {
                    res = res + "&query[to_date]=" + this.filter_to_date;
                }

                if (this.filter_phone != "") {
                    res = res + "&query[phone]=" + this.filter_phone;
                }

                if (this.filter_order_id != "") {
                    res = res + "&query[order_id]=" + this.filter_order_id;
                }

                if (this.sort_field != null) {
                    res = res + "&sort[field]=" + this.sort_field + "&sort[sort]=" + this.sort_sort;
                }

                if (this.filter_email != null) {
                    res = res + "&query[email]=" + this.filter_email;
                }

                return res;
            },
            queryInfo(){
                let transactionQuery = {
                  transaction_type: []
                }

                if(this.filter_transaction_type.length > 0){
                  this.filter_transaction_type.forEach((type, index) => {
                    transactionQuery.transaction_type[index] = type
                  })
                }

                if(this.advance_transaction_type.length > 0){
                  this.advance_transaction_type.forEach((type, index) => {
                    transactionQuery.transaction_type[index] = type
                  })
                }

                if (this.filter_gateway != null) {
                  transactionQuery.shop_type = this.filter_gateway.shop_type;
                  transactionQuery.shop_hashid = this.filter_gateway.hashid;
                }

                if(this.filter_status != null){
                    transactionQuery.status = this.filter_status
                }

                if(this.filter_from_date != null){
                    transactionQuery.from_date = this.filter_from_date
                }

                if(this.filter_to_date != null){
                    transactionQuery.to_date = this.filter_to_date
                }

                if(this.filter_card_number != ""){
                    transactionQuery.card_number = this.filter_card_number
                }

                if(this.filter_price != ""){
                    transactionQuery.price = this.filter_price
                }

                if(this.filter_ref_id != ""){
                    transactionQuery.ref_id = this.filter_ref_id
                }

                if(this.filter_id != ""){
                    transactionQuery.id = this.filter_id
                }
                
                if(this.filter_phone != ""){
                    transactionQuery.phone = this.filter_phone
                }

                if(this.filter_ref_num != ""){
                    transactionQuery.ref_num = this.filter_ref_num
                }

                if(this.filter_order_id != ""){
                    transactionQuery.order_id = this.filter_order_id
                }

                return transactionQuery
            },
            queryForExcel() {
                let res = {};

                if (this.filter_gateway != null) {
                    res.shop_type    = this.filter_gateway.shop_type;
                    res.terminal_id  = this.filter_gateway.terminal_id;
                }

                if (this.filter_ref_id != "") {
                    res.ref_id =this.filter_ref_id;
                }

                if (this.filter_id != "") {
                    res.id = this.filter_id;
                }

                if (this.filter_price != "") {
                    res.price = this.filter_price;
                }

                if (this.filter_ref_num != "") {
                    res.ref_num = this.filter_ref_num;
                }

                if (this.filter_card_number != "") {
                    res.card_number = this.filter_card_number;
                }

                if (this.filter_transaction_type != null) {
                    res.transaction_type = this.filter_transaction_type;
                }

                if (this.advance_transaction_type != null) {
                    res.transaction_type = this.advance_transaction_type;
                }

                if (this.filter_status != null) {
                    res.status = this.filter_status;
                }

                if (this.filter_from_date != null) {
                    res.from_date = this.filter_from_date;
                }

                if (this.filter_to_date != null) {
                    res.to_date = this.filter_to_date;
                }

                if (this.sort_field != null) {
                    res.sort_field = this.sort_field;
                    res.sort_sort = this.sort_sort;
                }

                return res;
            },
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },
        methods: {
          excelExport(data) {
            let form = $('#excel-transaction-filter-form')

            form.validate({
              rules: {
                from_date: {
                  required: true,
                },
                to_date: {
                  required: true,
                },
              },
            });

            if (!form.valid()) {
              return;
            }

            this.status = "loading";

            const excel_query = {
              ...data.excel_query,
              transaction_type: Array.isArray(data.excel_query.transaction_type)
                  ? data.excel_query.transaction_type.map(type => (type === 'zero' ? 0 : type))
                  : data.excel_query.transaction_type,
            }

            transactionService.createExcelRequest({
              ...excel_query
            }).then(async (response) => {
              await this.$store.dispatch('transaction/fetchExcelRequests')
              this.toastr.success(response.data.message)
            }).catch(({response}) => {
              form.validate().showErrors(response.data.data)
            }).finally(() => {
              this.status = "ok";
            });

          },
            transactionLists(){
              this.transactions_list = true;
              this.excel_requests_list = false;
            },
            excelRequestsList(){
              this.transactions_list = false;
              this.excel_requests_list = true;
            },
            getShopType(shop_type) {
                if (shop_type == AllShopTypes.PAYMENT_HELPER) {
                    return  i18n.t('label.payment_helper')
                }
                if (shop_type == AllShopTypes.PAYMAN) {
                    return  i18n.t('label.payman')
                }
                if (shop_type == AllShopTypes.IVR) {
                    return  i18n.t('label.ivr')
                }
                if (shop_type == AllShopTypes.DEDICATED) {
                    return  i18n.t('label.dedicated')
                }
            },
            exportToExcel() {
                axios({
                    url: ApiUrl.path("transaction/excel-export"),
                    method: "GET",
                    params: this.queryForExcel,
                    responseType: "blob",
                }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "transactions.xlsx");
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
            },
            toPersianDateFormat(val) {
                if (val == undefined || val == null || val == "") {
                    return "";
                }

                val = String(val);

                return val.replace(/\-/g, "/");
            },
            sortBy(field) {
                this.sort_field = String(field);

                if (this.sort_sort == "desc") {
                    this.sort_sort = "asc";
                } else {
                    this.sort_sort = "desc";
                }

                this.get_data(this.transactions.path + "?page=1");
            },
            resetQuery() {
                this.filter_ref_id = "";
                this.filter_gateway = null;
                this.filter_id = "";
                this.filter_price = "";
                this.filter_card_number = "";
                this.filter_ref_num = "";
                this.filter_phone = "";
                this.filter_order_id = "";

                this.filter_transaction_type = [];
                this.advance_transaction_type = [];

                $('[data-id="filter_transaction_type"] .filter-option-inner-inner').text(
                    "نوع تراکنش"
                );

                $('[data-id="advance_transaction_type"] .filter-option-inner-inner').text(
                    "نوع تراکنش"
                );

                this.filter_status = null;
                $('[data-id="filter_status"] .filter-option-inner-inner').text("وضعیت");

                this.filter_from_date = null;
                this.filter_to_date = null;
                this.sort_field = null;
            },
            get_data(url, callback = () => {}) {
                this.status = "loading";
                ApiService.query(
                    url + this.query + "&perpage=" + this.perpage.value
                ).then((json) => {
                    this.transactions = json.data.data;
                    this.status = "ok";

                    if (json.data.message !== '' && json.data.message != null) {
                        this.error_message = json.data.message;
                        this.has_error = true;
                    } else {
                        this.has_error = false;
                        this.error_message = '';
                    }

                    callback();
                });
                this.$store.dispatch('transaction/fetchStatistics',this.queryInfo)
            },
            advance_get_data(url, callback = () => {}) {
                let reg = /^\d+$/;
                if (!reg.test(this.filter_phone) && this.filter_phone !== '') {
                    return this.toastr.error(i18n.t('label.phone_error'));
                }
              
                const hasPhoneOrEmail = (this.filter_phone && this.filter_phone !== '') ||
                                        (this.filter_email && this.filter_email !== '');
                const hasTransactionType = this.advance_transaction_type && this.advance_transaction_type.length > 0;
              
                if (hasPhoneOrEmail && !hasTransactionType) {
                    return this.toastr.error('هنگام جستجو با شماره موبایل یا ایمیل، حتماً باید نوع تراکنش را انتخاب کنید.');
                }
              
                this.hide_modal();
                this.status = "loading";  
              
                ApiService.query(url + this.query + "&perpage=" + this.perpage.value)
                    .then((json) => {
                        this.transactions = json.data.data;
                        this.status = "ok";
                    
                        if (json.data.message !== '' && json.data.message != null) {
                            this.error_message = json.data.message;
                            this.has_error = true;
                        } else {
                            this.has_error = false;
                            this.error_message = '';
                        }
                      
                        callback();
                    });
                  
                this.$store.dispatch('transaction/fetchStatistics', this.queryInfo);
            },
            reset_and_get() {
                this.resetQuery();
                this.get_data(this.transactions.path + "?page=1");
            },
            afterDispatch() {
                // document.getElementById('filter_phone') && Inputmask('09999999999').mask(document.getElementById('filter_phone'))
            },
            show_modal(){
                $('#advance_modal').modal('show')
            },
            hide_modal(){
                $('#advance_modal').modal('hide')
            }
        },
        mounted() {
            this.$store.dispatch('gateway/fetchShopData').finally(()=>{
                  this.afterDispatch()

            });
            ApiService.get("transaction", "").then((json) => {
                this.transactions = json.data.data;
                this.changeStatus("ok");
                this.is_init = true;
                this.status = "ok";
                setTimeout(function () {
                    $(".kt-selectpicker").selectpicker({
                        size: 5,
                        liveSearch: true,
                        noneResultsText: i18n.t("selectpicker.none_result"),
                        selectAllText: i18n.t("selectpicker.select_all"),
                        noneSelectedText: i18n.t('label.transaction_type'),
                    });
                }, 1000);
            })
            this.$store.dispatch('transaction/fetchExcelRequests')
            this.$store.dispatch('transaction/fetchStatistics')
        },
        watch: {
            filter_phone(val){
                let reg = /^\d+$/;
                if (!reg.test(val))
                   return  $("#advance_filter").validate().showErrors({filter_phone: i18n.t('label.phone_error')})
                $("#advance_filter").validate().showErrors({});

            },
            selectedShop(newShop) {
              this.filteredTerminals = newShop ? newShop.terminals : [];
              this.selectedTerminal = null;
            }
        }
    }
</script>

<style>
    #overlay {
        position: fixed; /* Sit on top of the page content */
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
        z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
        cursor: pointer; /* Add a pointer on hover */
    }

    table > tbody > tr:not(:last-child) > td {
        border-bottom: 1px solid #dedede;
    }

    /* Mobile card rows — same visual language as dashboard recent-transactions */
    .transaction-mobile-card {
        background: #fff;
        border: 1px solid rgba(0, 190, 165, .28);
        border-radius: 14px;
        padding: 12px 14px;
        margin-bottom: 10px;
        box-shadow: 0 0 5px rgba(140, 227, 214, .45);
    }

    .transaction-mobile-card a {
        display: block;
    }

    .transaction-id {
        font-size: 13px;
        color: rgba(18, 44, 52, .7);
    }

    .transaction-price {
        font-size: 14px;
        font-weight: 700;
        color: rgba(18, 44, 52, 1);
        white-space: nowrap;
    }

    .transaction-meta {
        font-size: 12px;
        color: rgba(18, 44, 52, .7);
    }

    .transaction-mobile-card .label {
        font-size: 11px;
    }

    /* Compact transaction-type selector dropdowns (filter bar + advanced search) */
    .tx-type-filter .bootstrap-select .dropdown-menu {
        max-height: 200px;
        overflow-y: auto;
    }

    .tx-type-filter .bootstrap-select .dropdown-menu li {
        margin-bottom: 0 !important;
    }

    .tx-type-filter .bootstrap-select .dropdown-menu li a,
    .tx-type-filter .bootstrap-select .dropdown-menu.inner > li > a {
        padding: 8px 12px;
        font-size: 12px;
        line-height: 1.4;
    }

    .tx-type-filter .bootstrap-select .bs-searchbox {
        display: none;
    }

    .tx-type-filter .bootstrap-select .bs-searchbox .form-control {
        height: 30px;
        min-height: 30px;
        padding: 4px 10px;
        font-size: 12px;
        border-radius: 10px;
    }

    .w-47{
        width: 46.5% !important;
    }

    @media(max-width:992px){
        .w-47{
            width: 43.8% !important;
        }
    }

    @media(max-width:678px){
        .w-47{
            width: 42% !important;
        }
        .mt-sm-size{
            margin: 1rem 0;
        }
    }
    input[type="text"]::-webkit-input-placeholder {
        text-align: right;
    }
    div #filter_transaction_type-error{
        margin: 0.4rem -2rem !important;
    }
    div #filter_transaction_type-error{
        margin: 0.4rem -2rem !important;
    }
    div #advance_transaction_type-error{
        margin: 0.4rem -2rem !important;
    }
    div #advance_transaction_type-error{
        margin: 0.4rem -2rem !important;
    }
</style>
